import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import CheckboxChecked from "rialto-icons/CheckboxChecked";
import CheckboxUnchecked from "rialto-icons/CheckboxUnchecked";

import Translate from "utils/translate";

import styles from "./Checkbox.css";

const { t } = new Translate();

const Checkbox = ({ children, isChecked, isDisabled, isRequired, label, onChange }) => (
  <div
    className={cx(styles.checkbox, {
      [styles.selected]: isChecked,
      [styles.disabled]: isRequired || isDisabled,
    })}
    onClick={isRequired ? undefined : onChange}
  >
    {isChecked ? <CheckboxChecked /> : <CheckboxUnchecked />}
    {label && <span className={styles.label}>{label}</span>}
    {children}
    {isRequired && <div className={styles.required}>{t("default")}</div>}
  </div>
);

Checkbox.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default Checkbox;
